import type { TableRowVariant } from './types'

export const TABLE_ROW_VARIANT_CLASSES: Record<TableRowVariant, string> = {
	default: '',
	archived: 'opacity-50 hover:opacity-80 transition-opacity',
	muted: 'opacity-50 hover:opacity-80 transition-opacity',
	warning: 'bg-warning/10 hover:bg-warning/15',
	danger: 'bg-destructive/10 hover:bg-destructive/15',
	success: 'bg-success/10 hover:bg-success/15',
	info: 'bg-info/10 hover:bg-info/15',
}

export function getTableRowVariantClass(variant?: TableRowVariant): string {
	if (!variant || variant === 'default') {
		return ''
	}
	return TABLE_ROW_VARIANT_CLASSES[variant] ?? ''
}
